module.exports = __webpack_public_path__ + "img/py.bb1899d3.svg";